var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeekBackward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2308 29.9298C62.3448 38.6835 60.2048 50.7363 51.451 56.8502C42.6973 62.9641 30.6445 60.8241 24.5306 52.0704C21.4732 47.6929 20.4794 42.4955 21.3451 37.6203C21.5785 36.3061 20.7024 35.0517 19.3882 34.8183C18.0741 34.585 16.8196 35.4611 16.5863 36.7752C15.5056 42.8611 16.7472 49.3674 20.5681 54.8379C28.2105 65.7801 43.2764 68.4552 54.2186 60.8127C65.1608 53.1703 67.8358 38.1044 60.1934 27.1622C56.3725 21.6916 50.6914 18.2861 44.6055 17.2056C43.7569 17.0549 42.5961 16.8833 41.3853 16.7164L45.1605 14.0797C46.2548 13.3154 46.5223 11.8088 45.758 10.7146C44.9938 9.62039 43.4872 9.35288 42.393 10.1171L33.4773 16.3442C32.3831 17.1084 32.1156 18.615 32.8798 19.7092L39.1068 28.6249C39.8711 29.7191 41.3777 29.9866 42.4719 29.2224C43.5661 28.4582 43.8336 26.9516 43.0694 25.8573L39.9563 21.4001C41.4072 21.5945 42.8207 21.7976 43.7606 21.9645L43.7606 21.9645C48.6359 22.8301 53.1735 25.5523 56.2308 29.9298Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeekBackward);
export default __webpack_public_path__ + "static/media/SeekBackward.a77e0263922e2e557fabc279f2a77d2a.svg";
export { ForwardRef as ReactComponent };